import React, { Component } from 'react';
import { Dialog, DialogHeader, DialogBody } from '../../../../presentation/Dialog';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Alerts from '../../../../prototypes/Alerts';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import EtelAPI from '../../../../api/EtelAPI';

class SpeechTranscriptionsDialog extends Component {
  constructor( props ) {
    super( props );

    this.state = {
      showAmazon: true,
      showVosk: true,
      speechTranscriptions: []
    };

    this.onHandleClickCheckbox = this.onHandleClickCheckbox.bind( this );
  }

  /****************************************************************************
   * STATE / LIFECYCLE METHODS
   ***************************************************************************/

  componentDidMount() {
    this.alert = new Alerts( this.props.bugsnag, this.props.dispatch );

    this.getData( this.props.selectedTranscription );
  }

  /****************************************************************************
   * API CALLS
   ***************************************************************************/

  getData( selectedTranscription ) {
    const params = [
      { PDNIS: selectedTranscription.PDNIS || '' },
      { START_DATE: selectedTranscription.CCFILEDATE || '' },
      { END_DATE: selectedTranscription.CCFILEDATE || '' },
      { M_UUID: selectedTranscription.M_UUID || '' },
      { ANI: selectedTranscription.ANI || '' },
      { RETURN_TRANSCRIPTIONS: 1 }
    ];

    this.getSpeechTranscriptions( params ).then( ( speechTranscriptionsResults ) => {
      this.setState( {
        speechTranscriptions: speechTranscriptionsResults,
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  getSpeechTranscriptions( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'speechtranscriptions' );

      api.get( params ).then( ( speechTranscriptionsResults ) => {
        resolve( speechTranscriptionsResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /****************************************************************************
   * EXCEPTION HANDLING
   ***************************************************************************/

  doLogOff() {
    const { dispatch, auth, history } = this.props;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const { dispatch, bugsnag } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;

    if ( status === 410 ) {
      alerts.INFO( this.title, 'Your session has expired.', 5000 );
      this.doLogOff();
    } else if ( status === 500 ) {
      alerts.INFO( this.title, e.statusText, 5000 );
    } else {
      if ( e.statusText !== undefined ) {
        alerts.CRITICAL( this.title, e, false );
      } else {
        alerts.CRITICAL( this.title, e );
      }
    }
  }

  /****************************************************************************
   * EVENT HANDLERS
   ***************************************************************************/

  onHandleClickCheckbox( e ) {
    this.setState( {
      [e.target.name]: e.target.checked
    } );
  }

  /****************************************************************************
   * RENDERS
   ***************************************************************************/

  renderBody() {
    const transcriptions = [...this.state.speechTranscriptions];

    const transcriptionsTextareas = [];
    const filterCheckboxes = [];
    for ( let transcription of transcriptions ) {
      const service = transcription.SERVICES.charAt( 0 ).toUpperCase() + transcription.SERVICES.slice( 1 );
      const parsedTranscription = transcription.PARSED_TRANSCRIPTION || '';

      if ( this.state[`show${service}`] ) {
        transcriptionsTextareas.push(
          <div
            key={`transcription-textarea-${service}`}
            style={{
              display: 'flex',
              flexFlow: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              margin: '10px'
            }}
          >
            <h4 style={{ display: 'flex', justifyContent: 'center' }}>{service}</h4>
            <textarea className='speech-transcriptions-dialog-textarea' value={parsedTranscription} readOnly={true} cols={90}></textarea>
          </div>
        );
      }

      filterCheckboxes.push(
        <span
          key={`speech-transcriptions-dialog-checkbox-group-${service}`}
          className='speech-transcriptions-dialog-checkbox-group'>
          <input
            className='speech-transcriptions-dialog-filter-checkbox'
            type='checkbox'
            name={`show${service}`}
            checked={this.state[`show${service}`]}
            onChange={this.onHandleClickCheckbox}
          />
          <label className='speech-transcriptions-dialog-filter-labels'>{service}</label>
        </span>
      );
    }

    if ( transcriptionsTextareas.length === 1 ) {
      transcriptionsTextareas[0].props.style.width = '100%';
    }

    return (
      <div className='speech-transcriptions-dialog-body-container'>
        <div className='speech-transcriptions-dialog-filter-container'>
          <label className='speech-transcriptions-dialog-filter-labels'>Services:</label>
          {filterCheckboxes}
        </div>
        <div className='speech-transcriptions-dialog-transcriptions-container'>
          {transcriptionsTextareas}
        </div>
      </div>
    );
  }

  render() {
    const selectedTranscription = this.props.selectedTranscription;

    return (
      <Dialog show={this.props.show} width={90} height={90} >
        <DialogHeader caption={`Transcription - ${selectedTranscription.PDNIS} - ${selectedTranscription.M_UUID}`} closeButton onClose={this.props.onClose} />
        <DialogBody>
          {
            this.renderBody()
          }
        </DialogBody>
      </Dialog>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( SpeechTranscriptionsDialog )
);



// WEBPACK FOOTER //
// ./src/content/enterprise/speechtranscriptions/components/SpeechTranscriptionsDialog.js